import React from 'react';

export const AdminButton = ({
  children,
  variant = 'primary',
  className = '',
  icon: Icon,
  ...props
}) => {
  const base = variant === 'primary' ? 'admin-btn-primary' : 'admin-btn-ghost';
  return (
    <button type="button" className={`${base} ${className}`} {...props}>
      {Icon && <Icon className="w-4 h-4" strokeWidth={2} />}
      {children}
    </button>
  );
};

export default AdminButton;
